import { useInterval } from "usehooks-ts";
import { useState } from "react";

export const WEATHER_TILES_REFRESH_INTERVAL_MS = 2 * 60 * 1000;

export function getWeatherTilesUrl(params: {
  weatherLayer: string;
  weatherDateTime: string;
  weatherAltitude: string;
}) {
  const configuredServerUri = process.env.REACT_APP_SERVER_URI;
  if (configuredServerUri == null) throw new Error("REACT_APP_SERVER_URI must be configured");

  const serverUri = configuredServerUri.replace(/\/$/, "");

  return (
    `${serverUri}/api/map/tiles/${encodeURIComponent(params.weatherLayer)}/` +
    `{z}_${encodeURIComponent(params.weatherAltitude)}_{x}_{y}_` +
    `${encodeURIComponent(params.weatherDateTime)}.png`
  );
}

export function useWeatherTilesRefreshKey() {
  const [refreshKey, setRefreshKey] = useState(() => Date.now());

  useInterval(() => {
    setRefreshKey(Date.now());
  }, WEATHER_TILES_REFRESH_INTERVAL_MS);

  return refreshKey;
}
